import { UPDATECART } from "@/src/lib/util/config";
import { useState } from "react";
import { clearAllCart } from "@/src/lib/store/add-to-cart/slice";
import { useDispatch } from "react-redux";
import { useToast } from "@/src/lib/hooks/useToast";
import { cartApiService } from "@/src/lib/api-services/cartApiServices";
import { VISITTYPE } from "@/src/lib/util/config";
import Progressbar from "../../loading";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";
import useAuth from "@/src/lib/hooks/useAuth";
import CustomButton from "@/src/lib/ui/Button";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import { CustomRadioGroup } from "@/src/lib/ui/customRadioGroup";

const ChooseCart = ({ handleClose, isTestAddInCart, refetchCheckoutData }) => {
    const [value, setValue] = useState(UPDATECART.NEW);
    const { showCustomToast } = useToast();
    const reduxDispatch = useDispatch();
    const { isLoggedIn } = useAuth();
    const { refetch: isCartCountRefetch } = useCustomQuery(
        "cart_count",
        cartApiService.getCartCount,
        {
            enabled: isLoggedIn && isLoggedIn,
        }
    );

    const { mutate, isLoading: isPending } = useHODMutation(
        (data) => cartApiService.removeAllCart(data),
        {
            onSuccess: (data) => {
                refetchCheckoutData();
                showCustomToast("Tests removed successfully.", "success");
                isCartCountRefetch();
            },
            onError: (error) => {
                showToast(error, "error");
            },
        }
    );

    const removeLogoutCartHandler = () => {
        reduxDispatch(clearAllCart());
        showCustomToast("Tests removed successfully.", "success");
        setValue(UPDATECART.NEW);
        handleClose();
    };

    const onUpdateCartHandler = () => {
        if (value === UPDATECART.OLD) {
            removeLogoutCartHandler();
        } else {
            const payload = { visitType: VISITTYPE.CENTRE };
            mutate(payload);
        }
    };

    const testRemoveHandler = () => {
        removeLogoutCartHandler();
    };

    return (
        <div className="md:p-2 p-1">
            <p className="font-bold text-xl mb-4">
                Items already exists in the cart for your account!
            </p>

            <p>Please select the cart you wish to continue.</p>

            <CustomRadioGroup
                value={value}
                onChange={(_, val) => setValue(val)}
                name="radio-choose-cart-group"
            >
                <div
                    className={`px-6 py-3 w-full font-bold justify-between flex items-center gap-4 border border-solid border-gray-200 rounded-md mt-4 ${
                        value == UPDATECART.NEW
                            ? "bg-primary/10 border-primary"
                            : "bg-gray-100 "
                    }`}
                >
                    <input
                        type="radio"
                        value={UPDATECART.NEW}
                        className="w-4 h-4 bg-primary"
                        style={{
                            transform: "scale(1.5)",
                        }}
                    />

                    <div className="font-medium text-black leading-6 flex items-center gap-2 justify-between w-full">
                        Recent Cart
                    </div>
                </div>

                <div
                    className={`px-6 py-3 mt-4 w-full font-bold justify-between flex items-center gap-4 border border-solid border-gray-200 rounded-md ${
                        value == UPDATECART.OLD
                            ? "bg-primary/10 border-primary"
                            : "bg-gray-100"
                    }`}
                >
                    <input
                        type="radio"
                        value={UPDATECART.OLD}
                        className="w-4 h-4 bg-primary"
                        style={{
                            transform: "scale(1.5)",
                        }}
                    />

                    <div className="font-medium text-black leading-6 flex items-center gap-2 justify-between w-full">
                        Existing Cart
                    </div>
                </div>
            </CustomRadioGroup>

            {value === UPDATECART.OLD &&
                isTestAddInCart?.patients?.length > 0 && (
                    <>
                        <p className="font-bold text-lg mb-2 mt-2">
                            Existing Cart Details
                        </p>

                        <div className="grid gap-2 grid-cols-2">
                            {isTestAddInCart.patients.map(
                                ({ patientGuid, patientName, items }) => (
                                    <div
                                        key={patientGuid}
                                        className="rounded-md mb-4 border border-solid border-slate-200"
                                    >
                                        <p className="text-sm font-bold bg-gray-100 p-2">
                                            {patientName}
                                        </p>

                                        <div className="mt-1 p-2 gap-2 flex flex-row flex-wrap">
                                            {items?.map(({ itemName }) => (
                                                <CustomTooltip title={itemName}>
                                                    <p
                                                        key={itemName}
                                                        className="text-xs truncate border border-solid border-gray-200 p-1 rounded-md"
                                                    >
                                                        {itemName}
                                                    </p>
                                                </CustomTooltip>
                                            ))}
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </>
                )}

            <div className="mt-4 flex flex-row gap-2">
                <CustomButton
                    fullWidth
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={onUpdateCartHandler}
                    disabled={isPending}
                >
                    {isPending ? <Progressbar /> : "Continue"}
                </CustomButton>

                <CustomButton
                    variant="outlined"
                    fullWidth
                    onClick={testRemoveHandler}
                >
                    Cancel
                </CustomButton>
            </div>
        </div>
    );
};

export default ChooseCart;
